"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var isNetworkErrorRecoverable_1 = require("../../Http/isNetworkErrorRecoverable");
function createPlayerConfig(abrManager, shaka, player, baseConfig) {
    var config = Object.assign({}, baseConfig, {
        abrFactory: function () {
            return abrManager;
        },
        streaming: {
            retryParameters: {
                /*
                 * note: Disable Shaka's implementation of timeout.
                 *       The heuristic implements its' own timeout mechanism
                 */
                timeout: 0,
                /*
                 * note: Setting DAZN's retry mechanism to only try each fragment download once.
                 *       The 'failureCallback' is invoked when we timeout fragment download
                 */
                maxAttempts: 1,
                /*
                 * note: Configure Shaka's retry mechanism with zero delay, so that it reports http timeout
                 *       as an error to 'failureCallback' immediately.
                 *       The heuristic will take care of retry logic internally.
                 */
                baseDelay: 0,
                fuzzFactor: 0
            },
            failureCallback: function (error) {
                var retryStreamingCallback = player.retryStreaming.bind(player);
                if (isNetworkErrorRecoverable_1.default(shaka, error)) {
                    abrManager.onFailureCallback(retryStreamingCallback);
                }
                else {
                    if (baseConfig.failureCallback) {
                        baseConfig.failureCallback(error);
                    }
                    else {
                        /// @note Errors are also reported via Shaka Player's normal error handler
                    }
                }
            }
        }
    });
    return config;
}
exports.default = createPlayerConfig;
//# sourceMappingURL=createPlayerConfig.js.map